export default {
  'DisabledCell.TD.Reactivate': ({ }, outlet) => {
    outlet({ action: 'reactivate' })
  },
  'DisabledCell.TD.Archive': ({ }, outlet) => {
    outlet({ action: 'archive' })
  },
}